import * as React from 'react';
import autobind from 'autobind-decorator';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';

interface IProps {
    saveCallBack: any;
    closeCallBack: any;
    heading: string;
    title: string;
    description: string;
}

export default class GenericForm extends React.Component<IProps, {}> {

    @autobind
    public handleSave(event) {
        event.preventDefault();
        const form = event.currentTarget;
        let formData = new FormData();
        formData.append('title', form.title.value.trim());
        formData.append('description', form.description.value.trim());
        this.props.saveCallBack(formData);
    }

    public render() {
        return (
            <Card>
                {/* <Card.Header>{this.props.heading}</Card.Header> */}
                <Card.Body>
                    <Form onSubmit={this.handleSave}>
                        <Form.Group controlId="title" >
                            <Form.Label>Title</Form.Label>
                            <Form.Control size="sm" required type="text" defaultValue={this.props.title} placeholder="Enter title" />
                        </Form.Group>
                        <Form.Group controlId="description">
                            <Form.Label>Description</Form.Label>
                            <Form.Control size="sm" as="textarea" rows={4} defaultValue={this.props.description} placeholder="Enter Description" />
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Col sm={{ span: 12 }}>
                                <Button className="btn btn-sm" variant="success" type="submit">Save</Button>
                                <Button className="btn btn-sm mx-2" variant="danger" onClick={this.props.closeCallBack}>Cancel</Button>
                            </Col>
                            {/* <Col sm={{ span: 4, offset: 2 }}>
                            </Col>
                            <Col sm={{ span: 4, offset: 2 }}>
                            </Col> */}
                        </Form.Group>
                    </Form>
                </Card.Body>
            </Card>
        );
    }
}